import styled from 'styled-components';
 
const MyDiv = styled.div`
.headerGrid {
  grid-template-columns: repeat(10, 1fr);
}
 
.card_box {
  background: white;
  padding: 15px 10px;
  border-radius: 16px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: column;
  justify-content: space-between;  

}
 
.card_label {
  font-family: Poppins;
  font-weight: 500;
  font-size: 16px;
 
  color: #23272E;
}
 
.card_value {
  font-family: Poppins;
  font-weight: 600;
  font-size: 46px;
  color: #23272E;
  margin: 8px 0;
}
 
.button {
  border-radius: 44px;  
}
 
.headings {
  font-family: Poppins;
  font-weight: 600;
  font-size: 16px;
 
  margin-bottom: 8px;
  color: black;
 
}    
 
.txt {
  font-family: Poppins;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0%;
  color: black;
 
}
 
.divider {
  border-color: #E2E8F0;
  margin: 8px 0;
}
 
.highlight {
  color:  #B1B1B1;
  font-weight: 500;
}
 
.caption {
  font-family: Poppins;
  font-weight: 500;
  font-size: 12px;
  color: #B1B1B1;
}
 
`;
 
export default MyDiv;
 